export default function wireFitmentListeners(segment, ctx) {
    const { $uiEvents } = ctx

    $uiEvents.$on('fitmentChanged', emitFitmentChanged)

    // Emit when a USER changes fitment (ignore auto-fill)
    const primaryFitment = segment.getFitment()

    function emitFitmentChanged({ sourceType, newValue, layoutPosition }) {
        const type = sourceType.replace('Slug', '') // Cleanup type passed by Drills
        const value = typeof newValue === 'number' ? newValue.toString() : newValue // Convert number values to string

        segment.track(`Fitment: Selected: ${type}`, {
            [type]: value,
            ...(layoutPosition && { layoutPosition }),
        })

        // store ymm in a variable to send to segment when model is selected
        if (type === 'year' || type === 'make' || type === 'model') primaryFitment[type] = value

        // send ymm to segment when model is selected
        if (type === 'model') {
            if (layoutPosition) primaryFitment.layout_position = layoutPosition
            segment.track('Fitment: Selected: Primary YMM', primaryFitment)
            // also send primary fitment as user trait
            segment.emitIdentifyFitment(primaryFitment)
        }
    }
}
